import { motion, useScroll, useSpring } from "framer-motion";

/** Thin brand-coloured reading progress bar at the top of the page. */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.2 });
  return <motion.div aria-hidden style={{ scaleX }} className="fixed top-0 left-0 right-0 h-[3px] origin-left bg-primary z-[60] pointer-events-none" />;
};
